<template>
    <div id="unityCenter" :class="$root.isMob() ? 'mob' : ''" v-loading="loading">
        <div v-if="loading" class="loadingAlert">
            <el-alert
                title="加载中"
                description="正在加载数据,这可能需要一些时间,请稍后..."
                type="warning"
                center
                show-icon
                :closable="false">
            </el-alert>
        </div>
        <div class="title">
            <h2><i class="el-icon-info icon"></i>{{ clinet=="unity"?'数智WEB':'数智VR' }}</h2>
        </div>
        <div class="cate">
            <div class="item">
                <el-tag type="success" @click="changeCate(0)">全部</el-tag>
            </div>
            <div class="item" v-for="item in cate" :key="'cate_'+item.id">
                <el-tag type="success" @click="changeCate(item.id)">{{item.name}}</el-tag>
            </div>
        </div>
        <div class="list">
            <div class="item" v-for="item in data" :key="item.id" @click="view(item)">
                <div class="img">
                    <img :src="API + item.cover_img"/>
                    <span class="tag" v-if="item.is_vr==2">VR</span>
                </div>
                <div class="content">
                    <div class="title">
                        <h3>{{ item.name }}</h3>
                    </div>
                    <div class="describe">
                        {{ item.describe }}
                    </div>
                </div>
            </div>
            <div class="empty" v-if="data.length == 0">
                <el-empty description="暂无数据"></el-empty>
            </div>
        </div>
        <div class="page">
            <el-pagination background layout="prev, pager, next" :page-count="lastPage" @current-change="changePage"></el-pagination>
        </div>
    </div>
</template>
<script>
export default {
  name: 'unityCenter',
  props: {
    clinet : {
      type: String,
      default: "unity"
    },
  },
  watch: {
    "currentPage" () {
        this.getList(this.currentCate,this.currentPage);
    },
    "currentCate"(){
        this.getList(this.currentCate,1);
    },
    "data"(){
        if(this.cate.length > 0 && this.data.length > 0){
            this.loading = false;
        }
    },
    "cate"(){
        if(this.cate.length > 0 && this.data.length > 0){
            this.loading = false;
        }
    },
    "clinet"(){
        this.currentCate = 0;
        this.getList(0,this.page);
    }
  },
  data() {
    return {
        loading:true,
        data:[],
        cate:[],
        currentCate:0,
        API: window.config.api,
        lastPage:1,
        currentPage:1,
    }
  },
  methods: {
    async getList(cate=0,page=1){
        this.loading = true;
        let data = await this.$root.getDjArticle('',cate,page);
        this.data = data.data.data;
        if(this.clinet == 'unity'){
            //剔除vr项目
            this.data = this.data.filter(item => item.is_vr != 2);
        }
        if(this.clinet == 'unityVr'){
            //剔除web项目
            this.data = this.data.filter(item => item.is_vr == 2);
        }
        if(this.data.length == 0){
            this.loading = false;
        }
                this.data.forEach(item => {
            let strLeng = item.describe.length;
            item.describe = item.describe.substring(0,150);
            if(strLeng > 150){
                item.describe = item.describe + "...";
            }            
        });        
        this.lastPage = data.data.last_page;
    },
    async getCate(){
        let data = await this.$root.getDjCate();
        this.cate = data.data;
    },
    changePage(page){
        this.currentPage = page;        
    },
    changeCate(type){
        this.currentCate = type;
    },
    view(item){
        this.$emit('viewDetail',item.id,item.name);
    },
  },
  created() {
    this.getCate();
    this.getList(0,this.page);
  }
}
</script>
<style scoped lang="scss" src="@/assets/css/lib/unityCenter.scss">
</style>